import moment from 'moment-timezone';

// compare current with previous object
// @keys - an array of object keys
// @ignore - compare or exclude object keys
// @initObject - object for first comparison
const objectHasChanged = (keys = [], ignore = true, initObject = {}) => {
    let oldObject = initObject;

    return (object) => {
        let changed = false;

        for (let key in object) {
            if (ignore && keys.indexOf(key) !== -1 || !ignore && keys.indexOf(key) === -1) {
                continue;
            }

            if (_getValue(object[key]) !== _getValue(oldObject[key])) {
                changed = true;
                break;
            }
        }

        oldObject = object;

        return changed;
    }
};

const _getValue = (value) => {
    if (value instanceof moment) {
        return value.unix();
    }

    return value;
};

export default objectHasChanged;
